import { makeAutoObservable } from "mobx";
import AuthRequest from "../services/AuthServices";

export default class AuthStore {
  username = "";
  password = "";
  error = "";
  userId = "";
  isAuth = false;
  isLoading = false;

  constructor() {
    makeAutoObservable(this);
    this.loadUserId();
    const token = localStorage.getItem("token");
    if (token) {
      this.setAuth(true);
    }
  }

  loadUserId() {
    const savedUserId = localStorage.getItem("userId");
    if (savedUserId) {
      this.userId = savedUserId;
    }
  }

  saveUserId(userId) {
    this.userId = userId;
    localStorage.setItem("userId", userId);
  }

  setUsername(username) {
    this.username = username;
  }

  setPassword(password) {
    this.password = password;
  }

  setError(error) {
    this.error = error;
  }

  setAuth(auth) {
    this.isAuth = auth;
  }

  setLoading(load) {
    this.isLoading = load;
  }

  logIn = async () => {
    this.setError("");
    this.setLoading(true);
    try {
      const response = await AuthRequest.logIn(this.username, this.password);
      localStorage.setItem("token", response.accessToken);
      this.setAuth(true);
      this.saveUserId(response.user.id);
    } catch (error) {
      this.setError(error.message || "Ошибка входа");
      this.setAuth(false);
    } finally {
      this.setLoading(false);
    }
  };

  async checkAuth() {
    this.setLoading(true);
    try {
      const response = await AuthRequest.refresh();
      if (!response?.accessToken) {
        throw new Error("Нет токена");
      }
      localStorage.setItem("token", response.accessToken);
      this.setAuth(true);
      if (response.user?.id) {
        this.saveUserId(response.user.id);
      }
    } catch (error) {
      console.log(error);
      if (!localStorage.getItem("token")) {
        localStorage.removeItem("userId");
        this.userId = "";
        this.setAuth(false);
      }
    } finally {
      this.setLoading(false);
    }
  }

  async logout() {
    try {
      const response = await AuthRequest.logout();
      console.log(response);
    } catch (e) {
      console.log(e);
    } finally {
      localStorage.removeItem("token");
      localStorage.removeItem("userId");
      this.userId = "";
      this.setAuth(false);
    }
  }
}
